/* const fetchProductByHandle = (productHandle) => {
    return fetch('https://staging-teefury.myshopify.com/api/2021-10/graphql.json', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': '2333e96050b60a85cf5b84b0e08ec501'
        },
        body: JSON.stringify({
          query: `{
            productByHandle(handle: "${productHandle}") {
              id
              handle
              description
              title
              
              media(first: 100) {
                edges {
                  node {
                    alt
                    ... on MediaImage {
                      id
                      image {
                        src
                        altText
                        originalSrc
                        width
                        height
                        id
                      }
                    }
                  }
                }
              }


            }
          }`,
          variables: {},
        }),
    });
}

$(document).ready(function() {

    const $productList =  $(".rec-products-list");
    const $loader =  $("#rec_product_loader");
    const $pdpSlider = $("#add_on_overlay_content section.pdp-image-slider");
    const $genderSwatchElements = $("#add_on_overlay_content .gender-swatch-element");
    const genderActiveClass = "gender-swatch-element-active";

    $genderSwatchElements.click(function(e) {
        e.preventDefault();

        // Check if already selected
        if($(this).hasClass(genderActiveClass)) {
            return;
        }

        const productHandle = $(this).attr("href").replace("/products/", "");
        console.log(productHandle);

        $productList.hide();
        $loader.show();

        fetchProductByHandle(productHandle)
        .then((res) => res.json())
        .then((result) => {

            // Hide loader
            $productList.show();
            $loader.hide();

            /*
            console.log("Fetched Product Details: ");
            console.log(result);
            * /
            
            const productDetails = result.data.productByHandle;
            console.log(productDetails);

            const productMedia = productDetails.media.edges;

            // make selected
            $genderSwatchElements.find(`.${genderActiveClass}`).removeClass(genderActiveClass);
            $(this).addClass(genderActiveClass);

            var newProductImageHtml = "";
            var selectedColor = "";
            var productMediaIndex = 0;


            // Update image slide
            productMedia.forEach(function(media){

                const imageSrc = media.node.image.src;

                if(!imageSrc.includes("collection") && !imageSrc.includes("model-odad") && !imageSrc.includes("variant")) {

                    const imageAltText = media.node.image.altText;
                    const imageColor = imageSrc.split("-color-").pop().split("_")[0];

                    if(productMediaIndex == 0) {
                        selectedColor = imageColor;
                    }

                    newProductImageHtml += `<div class="zoom-img product__photo slide-color-${imageColor}">
                        <img src="${imageSrc}" alt="${imageAltText}" class="slick-slide-img">
                    </div>`;

                    productMediaIndex++;
                }

            });

            const productImages = $pdpSlider.find(".product__photo").length;
            if(productImages > 1) {

                $pdpSlider.slick("unslick");
                $pdpSlider.html(newProductImageHtml);

                $pdpSlider.slick({
                    infinite: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: true,
                    prevArrow: $('.slider__prev'),
                    nextArrow: $('.slider__next'),
                });

                if(CURRENT_SELECTED_COLOR) {
                    selectedColor = CURRENT_SELECTED_COLOR;
                }

                $pdpSlider.slick('slickFilter','.slide-color-'+selectedColor);
            }
        });
    });
});
*/
(function() {
let PRODUCT_VARIANTS = "";

$(document).ready(function() {
    $("#add_on_overlay_content a.rec-main-product").click(function(e){
        e.preventDefault();
        loadProductByHandle($(this).attr("href"));
    });
});

function setupEvents() {
    
    const $genderSwatchElements = $("#add_on_overlay_content .gender-swatch-element");
    const $styleSelect = $("#add_on_overlay_content select.pdp-2019-style-select");
    const $productTypeSelect = $("#add_on_overlay_content a.product-type--anchor");
    const $sizeSelector = $("#add_on_overlay_content .swatch-element__input");

    $("#add_on_overlay_content .close .no-thanks").hide();
    $("#add_on_overlay_content .close .back-to-cart").show();
    $("#add_on_overlay #add_on_overlay_content").addClass("product-loaded");

    $genderSwatchElements.off('click');
    $genderSwatchElements.click(function(e) {
        e.preventDefault();

        // Check if already selected
        if($(this).hasClass("gender-swatch-element-active")) {
            return;
        }

        loadProductByHandle($(this).attr("href"));
    });


    $styleSelect.off('change');
    $styleSelect.change(function(e){
        e.preventDefault();
        loadProductByHandle($(this).val());
    });

    $productTypeSelect.off('click');
    $productTypeSelect.click(function(e){
        e.preventDefault();
        loadProductByHandle($(this).attr("href"));
    });


    $sizeSelector.off('change');
    
    $sizeSelector.change(function() {
        // update active swatch element
        $(".swatch-element.swatch-element--active").removeClass('swatch-element--active');
        $(this).closest(".swatch-element").addClass('swatch-element--active');

        // $("select.single-option-selector[data-index='option3']").val($(this).val());
        const selectedVarientId = selectVariantId();

        PRODUCT_VARIANTS.forEach(function(variant){
            if(variant.id == selectedVarientId) {
                const thisVariantPrice = theme.Currency.formatMoney(variant.price, theme.moneyFormat);
                $('form.product-form span[id^="ProductPrice"]').html(thisVariantPrice);
            }
        });
    });

    function selectVariantId() {
        const selectedVariants = {};
        $('[id^="AddToCartForm"]').serializeArray().map(option => {
            selectedVariants[option.name] = option.value;
        });

        const selectedVariantName = ""
            + selectedVariants['option-0'] + " / " 
            + selectedVariants['option-1'] + " / " 
            + selectedVariants['option-2'];

        console.log(selectedVariantName);

        const $variantOptions = $('form[id^="AddToCartForm"] select[id^="ProductSelect"] option');
        $variantOptions.removeAttr("selected");

        let selectedVarientId = '';
        $variantOptions.each(function(){
            if($.trim($(this).text()) == selectedVariantName) {
                $(this).attr("selected", "selected");
                selectedVarientId = $(this).val();
            }
        });

        return selectedVarientId;
    }


    $("#add_on_overlay_content .btn-pdp-2019-add-to-cart").click(function(e){

        console.log("add_on_overlay_content btn-pdp-2019-add-to-cart click");

        e.preventDefault();

        const selectedVariantId = selectVariantId();
        const $loader =  $("#rec_product_loader");

        $loader.show();

        // Add to cart
        const params = {
            type: 'POST',
            url: '/cart/add.js',
            // data: $('[id^="AddToCartForm"]').serialize(),
            data: "id="+selectedVariantId,
            dataType: 'json',
            success: function() {
                // Refresh page
                window.location.reload();
            }
        }
        jQuery.ajax(params);
    });

    // Setup selected variants
    for(let i = 0; i < 3; i++) {
        const $swatchInput = $('[id^="AddToCartForm-"] [name^="option-'+i+'"]:first');
        $swatchInput.attr("checked", true);

        $swatchInput.closest(".swatch-element").addClass("swatch-element--active");
    }

}

function loadProductByHandle(handle) {

    const $productSection = $("#add_on_overlay_content section.product-template");
    const $loader =  $("#rec_product_loader");

    $loader.show();

    $.get("https://teefury.com"+ handle, function( data ) {
        
        $loader.hide();

        // const $pageDocument = 
        const pdpHtml = $(data).find("#ProductSection-product-template-2019").get(0).outerHTML;

        // console.log(pdpHtml);

        // $productSection.html($pageDocument.find("#ProductSection-product-template-2019").html());
        $("#add_on_overlay_content .rec-products-list").hide();
        $("#add_on_overlay_content #product_details").html(pdpHtml);

        setupEvents();

        // document.getElementById("ProductJson-").innerHTML
        const productData = JSON.parse($('[id^="ProductJson-"]').html());
        PRODUCT_VARIANTS = productData.variants;

        // console.log("PRODUCT_VARIANTS : ");
        // console.log(PRODUCT_VARIANTS);

        setTimeout(function(){
            // Hide loader
            $loader.hide();
            
        }, 500);
    });
}
})();